var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningIconAuth = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 6,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M7 4v4"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 10,
  r: 0.7,
  fill: "currentColor"
})));
export default SvgWarningIconAuth;